import collectionApiClient, {
  CollectionAnalyticsQueryParams,
  OrderGraphData,
} from '../../../api/collections';
import useKlydoQuery from '../../../hooks/useKlydoQuery';

const useCollectionOrdersGraphQuery = ({
  collectionId,
  period,
  enabled = true,
}: CollectionAnalyticsQueryParams) => {
  return useKlydoQuery<OrderGraphData>({
    queryKey: ['collectionOrdersGraph', collectionId, period],
    queryFn: () =>
      collectionApiClient.getCollectionOrdersGraph(collectionId, period),
    enabled: !!collectionId && enabled,
  });
};

export default useCollectionOrdersGraphQuery;
